export const Constants = {

    KEY: "!whats2bform!?*"
}